import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
//import ReactQuill from 'react-quill'
import CKEditor from "react-ckeditor-component"

import AceEditor from 'react-ace'; 
import 'brace/mode/java';
import 'brace/theme/github';

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import { 
	displayModalCreate,
	updateInputs,
	createOrUpdatePlantillas
} from '../../actions/plantillas'

class ModalCreate extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalCreate')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreate .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalCreate(false, '', ''), 300)
	}

	onChange = (newValue) => {
		this.props.updateInputs(`modalCreate.data.texto`, newValue)
	}


	render() {

		const { modalCreate, enums } = this.props
		if (!modalCreate.get('show')) {
			return null
		}


		return(
			<Modal id="modalCreate" show={ true } ZIndex={ 2000 } style={{ width: '70vw' }} >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.createOrUpdatePlantillas(modalCreate.get('data'), modalCreate.get('mode')) }} noValidate>
					<ModalHeader title={ modalCreate.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="floppy-o" disabled={ modalCreate.get('btnDisabled') } title="Guardar" />
					</ModalButtonStrip>
					<ModalBody >
						<div>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group">
                                        <label className="control-label">Nombre</label>
                                        <input type="text" className="form-control input-sm" value={ modalCreate.getIn(['data', 'nombre']) } onChange={ (e) => this.props.updateInputs(`modalCreate.data.nombre`, e.target.value) }  />
                                    </div>
								</div>
								<div className="col-md-3">
									<div className="form-group">
                                        <label className="control-label">Tipo de documento</label>
										<select className="form-control input-sm" value={ modalCreate.getIn(['data', 'tipo']) } onChange={ (e) => this.props.updateInputs(`modalCreate.data.tipo`, e.target.value) }>
											<option value={0} disabled>Seleccione una opción</option>
											{
												Object.keys(enums.documentos.tipos).map(a => {
													return (
														<option key={`opt21[${a}]`} value={a}>{ enums.documentos.tipos[a].NOMBRE }</option>
													)
												})
											}
										</select>
                                    </div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-12">
									<div className="form-group">

                                        <label className="control-label">Plantilla</label>

											<br/>

											<AceEditor 
												width={'100%'}
												mode="html" 
												theme="github"
												value={ modalCreate.getIn(['data', 'texto']) }
												onChange={ this.onChange } 
												name="editor_blaze"
												editorProps={{$blockScrolling: true}}
											/>

                                    </div>
								</div>
							</div>
						</div>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreate: state.plantillas.get('modalCreate'),
		enums: state.common.get('enums').toJS(),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalCreate: (show, title, mode) => dispatch(displayModalCreate(show, title, mode)),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
		createOrUpdatePlantillas: (data, mode) => dispatch(createOrUpdatePlantillas(data, mode)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Plantillas/ModalCreate.jsx